import { PopupLayout } from 'components/Blocks/Product/AddToCartPopup/PopupLayout';
import Button from 'components/Forms/Button/Button';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { useSessionStore } from 'store/useSessionStore';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

export type NotAddedProduct = {
    name: string;
    catnum: string | null;
};

type NotAddedProductsPopupProps = {
    notAddedProducts: NotAddedProduct[];
    onCloseCallback?: () => void;
};

export const NotAddedProductsPopup: FC<NotAddedProductsPopupProps> = ({ notAddedProducts, onCloseCallback }) => {
    const { t } = useTranslation();
    const router = useRouter();
    const { url } = useDomainConfig();
    const [cartUrl] = getInternationalizedStaticUrls(['/cart'], url);

    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);

    return (
        <PopupLayout
            heading={t('Some products could not have been added to your cart')}
            hideCloseButton={false}
            type="info"
            onCloseCallback={onCloseCallback}
        >
            <div className="mb-4 max-h-96 overflow-y-auto pr-2">
                <ul>
                    {notAddedProducts.map((product) => (
                        <li key={product.catnum ?? product.name} className="mb-2">
                            {product.catnum && `${product.catnum} `}
                            {product.name}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="mt-4 flex justify-end">
                <Button
                    onClick={() => {
                        onCloseCallback?.();
                        updatePortalContent(null);
                        router.push(cartUrl);
                    }}
                >
                    {t('Go to cart')}
                </Button>
            </div>
        </PopupLayout>
    );
};

export default NotAddedProductsPopup;
